import { ReplenishmentField } from '../models/replenishment.types'

export const REPLENISHMENT_DEFAULT_FIELDS: ReplenishmentField[] = [
  'replenishmentNumber',
  'createdAt',
  'movedQty',
  'priority',
  'product.SKU',
  'product._id',
  'warehouseId',
  'source._id',
  'target._id',
  'status',
  'requiredQty',
  'movedQty',
  'userId',
  'priority',
]
